import { Routes } from '@angular/router';
import { InternalRoutes } from './internal/internal.routes';
import { PublicRoutes } from './public/public.routes';

export const routes: Routes = [...InternalRoutes, ...PublicRoutes];
